"use client";
import Link from "next/link";
import { Icon } from "@iconify/react";

export default function CtaBanner() {
  return (
    <div className="max-w-[83.75rem] mx-auto bg-gradient-to-br from-primary to-danger rounded-[3rem] p-12 md:p-20 text-center relative overflow-hidden shadow-2xl">
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl translate-x-1/2 -translate-y-1/2"></div>

      <div className="relative z-10">
        <h2 className="text-40 md:text-5xl font-bold mb-6 text-white leading-tight">
          Ready to enhance your operation?
        </h2>
        <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">
          Discover how our intrinsic safety solutions can streamline your
          workflows and save lives.
        </p>
        <Link
          href="/contact"
          className="inline-flex items-center gap-3 bg-white text-muted px-10 py-5 rounded-full font-bold hover:bg-midnight hover:text-primary transition-all shadow-xl hover:shadow-2xl hover:-translate-y-1"
        >
          Get in Touch <Icon icon="ion:arrow-forward" />
        </Link>
      </div>
    </div>
  );
}
